// extracted by mini-css-extract-plugin
module.exports = {"photo-container":"dd31006766--photo-container--df9LX","mobile":"dd31006766--mobile--q4h_K","title":"dd31006766--title--UsCTn"};